import Vue from 'vue'
import Router from 'vue-router'
import main from '@/components/main';

Vue.use(Router)

// 解决重复点击导航时，控制台出现报错
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  mode: 'history',
  base: '/refs/',
  routes: [
    {
      path: '/',
      name: 'Main',
      redirect: '/',
      component: main,
      children: [
        {
          path: '/',
          name: 'Home',
          component: () => import('@/views/home/index.vue')
        },

      ]
    },{
      path: '/more',
      name: 'More',
      component: () => import('@/views/home/moreNews/index.vue')
    },
    {
      path: '/browse/species',
      name: 'Browse',
      component: () => import('@/views/browse/index.vue')
    },
    {
      path: '/browse/strain',
      name: 'Browse',
      component: () => import('@/views/browse/index.vue')
    },
    {
      path: '/browse/collectionid',
      name: 'Browse',
      component: () => import('@/views/browse/index.vue')
    },
    {
      path: '/browse/standard',
      name: 'Browse',
      component: () => import('@/views/browse/index.vue')
    },
    {
      path: '/browse/getinfo',
      name: 'BrowseDetail',
      component: () => import('@/views/browse/detail/index.vue')
    },
    {
      path: '/search',
      name: 'Search',
      component: () => import('@/views/search/index.vue')
    },
    {
      path: '/search/searchkey',
      name: 'searchkey',
      component: () => import('@/views/search/searchkey/index.vue')
    },
    {
      path: '/standards',
      name: 'Standards',
      component: () => import('@/views/standards/index.vue')
    },
    {
      path: '/history',
      name: 'History',
      component: () => import('@/views/history/index.vue')
    },
    {
      path: '/credit',
      name: 'Credit',
      component: () => import('@/views/credit/index.vue')
    },
    {
      path: '/wdcmsop',
      name: 'WDCMSOP',
      component: () => import('@/views/wdcmsop/index.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js